import { styled } from "goober";
import { config } from "../environment";
import { Backdrop } from "./Backdrop";
import { EmptyState } from "./EmptyState";

const Container = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  background: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  border-radius: 16px;
  box-shadow: var(--elevation-low);
  overflow: hidden;
`;

export function Watchtower() {
  return (
    <>
      <title>{`Watchtower • ${config.title}`}</title>
      <Backdrop permanentNavigation>
        <Container>
          <EmptyState
            iconName="tower-control"
            title="Watchtower"
            description="Browse every space and every member’s personal workflows and chats. Pick one from the sidebar to get started."
          />
        </Container>
      </Backdrop>
    </>
  );
}
